import { z } from 'zod';

export const transactionStatusSchema = z.enum(['pending', 'paid', 'failed', 'cancelled']);
export type TransactionStatus = z.infer<typeof transactionStatusSchema>;

export const paymentProviderSchema = z.enum(['robokassa', 'manual']);
export type PaymentProvider = z.infer<typeof paymentProviderSchema>;

export const transactionSchema = z.object({
  id: z.number().int().positive(),
  userId: z.number().int().positive(),
  packageId: z.number().int().positive().nullable(),
  provider: paymentProviderSchema,
  status: transactionStatusSchema,
  amount: z.number().int().nonnegative(),
  currency: z.string(),
  creditsAdded: z.number().int().nonnegative(),
  externalInvoiceId: z.string().nullable(),
  createdAt: z.string().datetime(),
  paidAt: z.string().datetime().nullable(),
});

export type Transaction = z.infer<typeof transactionSchema>;
